const features = [
	{
		label: `Users`,
		value: `100,000+`,
	},
	{
		label: `Credits Awarded Daily`,
		value: `170+`,
	},
	{
		label: `Accreditations`,
		value: `20+`,
	},
	{
		label: `5 Star Reviews`,
		value: `250+`,
	},
];

const Facts = () => {
	return (
		<section
			id="facts"
			aria-label="Facts & Figures"
			className="mx-auto px-6 py-10 sm:px-7 sm:py-10 lg:px-16 dark:bg-slate-800"
		>
			<div className="mx-auto flex max-w-screen-2xl flex-col gap-8 lg:gap-12 xl:gap-16">
				<div className="grid grid-cols-2 gap-8 sm:grid-cols-2 sm:gap-12 md:gap-16 lg:gap-12 xl:grid-cols-4">
					{features.map((feature) => (
						<div
							key={feature.label}
							className="mx-auto flex flex-col gap-2 rounded-xl text-center"
						>
							<h3 className="font-extrabold text-3xl text-slate-900 sm:text-4xl dark:text-slate-50">
								{feature.value}
							</h3>
							<p className="font-medium text-slate-700 sm:text-lg dark:text-slate-200">
								{feature.label}
							</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Facts;
